export default __webpack_public_path__ + "static/media/educast.ace8bac6.jpg";